import React from 'react';

const Footer = () => {
    return (
        <div className="w-full flex justify-center opacity-50">
            <h6 className="uppercase tracking-widest text-gray-400 text-xs lg:absolute bottom-0 mb-2 lg:mb-5">
                Made with{' '}
                <svg
                    className="w-5 h-5 inline"
                    fill="red"
                    stroke="red"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                    ></path>
                </svg>{' '}
                By Satej Bidvai {':)'}
            </h6>
        </div>
    );
};

export default Footer;
